// Library Imports
import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as CgIcons from 'react-icons/cg'
import * as MdIcons from 'react-icons/md'

// Asset Imports
import testimg from '../../assets/logo/select-sires-inc.png'
import '../../assets/css/stylesheets/components/card/VerticalEntryCard.css'

function VerticalEntryCard({ entry }) {
    

    const imageSrc = `data:image/jpeg;base64,${entry.Picture}`;
    const myStyle = {
        backgroundImage: `url(${imageSrc})`,
        backgroundSize: 'contain', // Example: scales image to cover the entire container
        backgroundRepeat: 'no-repeat', // Example: prevents image repetition
        backgroundPosition: 'center', // Example: centers the image within the container
        backgroundColor: 'white' // Fallback color
  }

    return (
        <div className="verticalentrycard slide-in-right">
            <div className="verticalentrycard-media" style={myStyle}>
            </div>
            <div className="verticalentrycard-content">
                <div className="verticalentrycard-content-main">
                    <div className="verticalentrycard-content-title">
                        {entry.OrganizationName || entry.LastName}
                    </div>
                    <div className="verticalentrycard-content-description">
                        {entry.OwnerName || entry.FirstName}
                    </div>
                    <div className="verticalentrycard-content-contact">
                        <div>
                            <MdIcons.MdLocationOn className="verticalentrycard-content-contact-icon" />
                            {entry.Address2
                                ? `${entry.Address1}, ${entry.Address2}, ${entry.City}, ${entry.StateProvince}, ${entry.ZipCode}`
                                : `${entry.Address1}, ${entry.City}, ${entry.StateProvince}, ${entry.ZipCode}`}
                        </div>
                        {entry.HomePhone && (
                            <div>
                                <MdIcons.MdPhone className="verticalentrycard-content-contact-icon" />
                                {entry.HomePhone}
                            </div>
                        )}
                        {entry.WorkPhone && (
                            <div>
                                <MdIcons.MdWork className="verticalentrycard-content-contact-icon" />
                                {entry.WorkPhone}
                            </div>
                        )}
                        {entry.CellPhone && (
                            <div>
                                <FaIcons.FaMobileAlt className="verticalentrycard-content-contact-icon" />
                                {entry.CellPhone}
                            </div>
                        )}
                        {entry.Email && (
                            <div>
                                <MdIcons.MdMail className="verticalentrycard-content-contact-icon" />
                                <a href={`mailto:${entry.Email}`}>{entry.Email}</a>
                            </div>
                        )}
                        {entry.Fax && (
                            <div>
                                <FaIcons.FaFax className="verticalentrycard-content-contact-icon" />
                                {entry.Fax}
                            </div>
                        )}
                    </div>
                </div>
                <div className="verticalentrycard-footer">
                    <div className="verticalentrycard-seperator"></div>
                    <div className="verticalentrycard-quick-actions">
                        {entry.WebsiteURL && (
                            <a href={entry.WebsiteURL} target="blank" rel="noopener">
                                <CgIcons.CgWebsite />
                            </a>
                        )}
                        {entry.FacebookURL && (
                            <a href={entry.FacebookURL} target="blank" rel="noopener">
                                <FaIcons.FaFacebookF />
                            </a>
                        )}
                        {entry.LinkedInURL && (
                            <a href={entry.LinkedInURL} target="blank" rel="noopener">
                                <FaIcons.FaLinkedinIn />
                            </a>
                        )}
                        {entry.YoutubeURL && (
                            <a href={entry.YoutubeURL} target="blank" rel="noopener">
                                <FaIcons.FaYoutube />
                            </a>
                        )}
                        {entry.InstagramURL && (
                            <a href={entry.InstagramURL} target="blank" rel="noopener">
                                <FaIcons.FaInstagram />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VerticalEntryCard;